import React from 'react';

import { MessageBodyStyle, MessageLabelStyle } from '@/components/MessageDialog/css';
import styles from '@/shared/styles';
import { isSPRSUserFromStorage } from '@/shared/utils/serviceKind';

/**
 * システムエラーダイアログの本文
 *
 * 問い合わせ先はSPRSユーザーとRoboRoboユーザーで異なる。
 */
const SystemErrorContents: React.FC = () => {
  const isSPRSUser = isSPRSUserFromStorage();
  const mailAddress = isSPRSUser
    ? import.meta.env.VITE_SPRS_MAIL_ADDRESS
    : import.meta.env.VITE_CS_CONTACT_MAIL_ADDRESS;

  return (
    <MessageBodyStyle>
      <MessageLabelStyle>
        エラーが発生しました。
        <br />
        {isSPRSUser
          ? 'SPRS担当者にご連絡ください。'
          : 'RoboRoboカスタマーサクセスチームにご連絡ください。'}
        <br />
        <a
          href={`mailto:${mailAddress}`}
          style={{
            textDecoration: 'none',
            color: styles.color.blue,
          }}
          rel="noopener noreferrer"
        >
          {mailAddress}
        </a>
      </MessageLabelStyle>
    </MessageBodyStyle>
  );
};

export default SystemErrorContents;
